import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../i18n/translate.js';
import Icon from '../../components/Icon/Icon.js';
import styles from './InstallationAddress.module.scss.js';

var InstallationAddress = function InstallationAddress(_ref) {
  var installationAddress = _ref.installationAddress,
    _onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("section", {
    id: "fixed-installation-address"
  }, _onClick ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    id: "settings-item-edit-address-not-allowed",
    className: styles.editInstallationAddressNotAllowed,
    onClick: function onClick() {
      return _onClick();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.text
  }, /*#__PURE__*/React.createElement("h2", {
    className: "title"
  }, t('MPLIB_SYSTEM_SETTINGS_INSTALLATION_ADDRESS_TITLE'))), /*#__PURE__*/React.createElement(Icon, {
    icon: "icon-arrow-right",
    className: styles.navigationArrow
  })) : /*#__PURE__*/React.createElement("h2", {
    className: "title"
  }, t('MPLIB_SYSTEM_SETTINGS_INSTALLATION_ADDRESS_TITLE')), /*#__PURE__*/React.createElement("p", {
    className: "secondary"
  }, installationAddress.firstName, " ", installationAddress.lastName), /*#__PURE__*/React.createElement("p", {
    className: "secondary"
  }, installationAddress.street), /*#__PURE__*/React.createElement("p", {
    className: "secondary"
  }, installationAddress.city), /*#__PURE__*/React.createElement("p", {
    className: "secondary"
  }, " ", installationAddress.postalNumber));
};
InstallationAddress.propTypes = {
  installationAddress: PropTypes.shape({
    street: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    postalNumber: PropTypes.string.isRequired
  }).isRequired,
  onClick: PropTypes.func
};
InstallationAddress.defaultProps = {
  onClick: undefined
};

export { InstallationAddress as default };
